<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Funny Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editFunny">Edit Funny</button>
                </div>
            </div>
            <div class="table-responsive" v-if="funny">
                <table class="table table-bordered table-light">
                    <tr>
                        <th>Id</th>
                        <td>{{funny.funnyId}}</td>
                    </tr>
                    <tr>
                        <th>Title</th>
                        <td>{{funny.funnyName}}</td>
                    </tr>
                    <tr>
                        <th>URL</th>
                        <td><a :href="funny.funnyUrl" target="_blank">{{funny.funnyUrl}}</a></td>
                    </tr>
                    <tr>
                      <th>Image</th>
                      <td><img class="table-thumbnail" :src="funny.funnyUrl" :title="funny.funnyUrl" /></td>
                    </tr>
                    <tr>
                      <th>Corporations</th>
                      <td>{{funny.csvCorporationName}}</td>
                    </tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="funny.active == '0'">Inactive</td>
                        <td v-else>Active</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'ViewFunny',
        components: {
            LTable,
        },
        created (){
            console.log('inside view funny')
        this.$store.dispatch('GETSELECTEDFUNNY', this.$route.params.id).then(() =>{
            console.log('selected', this.selectedFunny)
            this.funny = this.selectedFunny;
        })
    },
    data () {
        return {
          funny: {}
        }
    },
    methods: {
        editFunny(){
            this.$router.push({ name: 'EditFunny', params: { id: this.funny.funnyId}})
        },
    },
    computed: {...mapGetters([
        'selectedFunny'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Funnies/FunnyDetails.vue